export default __webpack_public_path__ + "static/media/JSON.10836232.png";